import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcBusFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.938 4.5v5.938h1.312a.75.75 0 0 1 0 1.5h-1.312v5.624c0 1.122-.74 2.072-1.757 2.388l.002 1.34a.75.75 0 1 1-1.5.002l-.002-1.23H7.187v1.23a.75.75 0 0 1-1.5 0v-1.344a2.5 2.5 0 0 1-1.75-2.386v-5.625H2.75a.75.75 0 0 1 0-1.5h1.188V4.5a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5m-14.5 5.938h13V6.874h-13zm2.252 6.187a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m8.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
    clipRule: "evenodd"
  }));
}
var IcBusFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcBusFill));

export { IcBusFill as I };
